
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

export interface EnhancedProcessingStatusProps {
  processingCandidates: Set<string>;
  setProcessingCandidates: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export const EnhancedProcessingStatus: React.FC<EnhancedProcessingStatusProps> = ({
  processingCandidates,
  setProcessingCandidates
}) => {
  if (processingCandidates.size === 0) {
    return null;
  }

  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardContent className="pt-4">
        <div className="flex items-center gap-2 text-blue-700">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="text-sm">
            Processing {processingCandidates.size} candidate{processingCandidates.size > 1 ? 's' : ''}...
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
